import { WidgetApiService } from "./widgetApiService";
import { ClientStore } from "../../stores/clientStore";

export interface ClientEndsService {
  generateClientEndsLink: (proposalId: number, email: string, exceededProxies: boolean, accountNumber?: string, contactCity?: string) => Promise<any>;
}

export class DefaultClientEndsService implements ClientEndsService {
  constructor(private clientStore: ClientStore, private widgetSrvc: WidgetApiService) {
  }

  public async generateClientEndsLink(proposalId: number, email: string, exceededProxies: boolean, accountNumber?: string, contactCity?: string): Promise<any> {
    return await this.clientStore.generateClientEndsLinkRequestStatus.handleRequest(
      () => this.widgetSrvc.generateClientEndsLink(proposalId, email, exceededProxies, accountNumber, contactCity)
    );
  }
}
